module.exports = __webpack_public_path__ + "static/media/brown-calendar.1b75698a.svg";